<template>
    <div class="profileView">
        
    </div>
</template>